module.exports = __webpack_public_path__ + "static/media/yunying6.8d638b0a.jpg";